import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import Drawer from '@mui/material/Drawer';
import TradeDetails from './TradeDetails.js';
import LaunchIcon from '@mui/icons-material/Launch';

function TradeDetailsDrawer(props) {

    const [drawerOpen, setDrawerOpen] = useState(false);


    return (
        <div>
            <Link className="drawer-link" onClick={() => setDrawerOpen(true)}>{props.link} <LaunchIcon fontSize='small' /></Link>
            <Drawer
                anchor={'left'}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
            >
                <div style={{ padding: '20px' }}>
                    <center><b><Link onClick={() => setDrawerOpen(false)}>CLOSE</Link></b></center>
                    <br></br>

                    <TradeDetails userId={props.userId} role={props.role} mobileView={props.mobileView} planTradeId={props.planTradeId} />
                    <br></br>
                    <center><b><Link onClick={() => setDrawerOpen(false)}>CLOSE</Link></b></center>
                </div>
            </Drawer>
        </div>
    );
}

export default TradeDetailsDrawer;